import React from 'react';
import { removeExtraSpaces } from '../../scripts/helpers';
import './icons-holder.scss';

export type IconsHolderShape = 'round' | 'square';
export type IconsHolderSize = 'xs' | 'sm' | 'md' | 'lg';
export type IconsHolderVariant = 'light' | 'primary' | 'danger' | 'success' | 'secondary';
type IconsHolderProps = {
  size?: IconsHolderSize;
  variant?: IconsHolderVariant;
  className?: string;
  class?: string;
  shape?: IconsHolderShape;
  icon?: string;
  step?: string;
};
class IconsHolder extends React.Component<IconsHolderProps> {
  constructor(props: IconsHolderProps) {
    super(props);
  }
  render() {
    const classBasename = 'icons-holder';
    const step = this.props.step || '';
    const size = step
      ? ''
      : this.props.size
      ? `${classBasename}-${this.props.size}`
      : `${classBasename}-md`;
    const variant = this.props.variant ? `${classBasename}-${this.props.variant}` : ' ';
    const cl = this.props.class || this.props.className || '';
    const shape = step
      ? `${classBasename}-round`
      : this.props.shape
      ? `${classBasename}-${this.props.shape}`
      : ' ';
    const icon = this.props.icon || '';
    const fullClass = removeExtraSpaces(
      `${classBasename} ${cl} ${step ? 'content-holder' : ''} ${icon} ${size} ${shape} ${variant}`,
    );
    return <span className={`${fullClass}`}>{step}</span>;
  }
}

export default IconsHolder;
